module.exports = __webpack_public_path__ + "static/img/yfjy_ios.ae682db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/yfjy_ios.png
// module id = kkJT
// module chunks = 41